import styled from "styled-components";

export const StyledInputContainer = styled.div<{ $size: string }>`
    margin-bottom: 10px;
    ${({ $size }) => ($size ? `width: calc(${$size} - 5px);` : "flex: auto; width: min-content;")}
`;
